import React from "react";

export const MinusCircleIcon = () => (
  <img className="minusCircleIcon" src="/images/MinusCircleIcon.png" alt="minus circle icon" />
);
